import { createSelector } from "reselect";

const selectCurrentDriver = (state) => state.currentDriver;

export const selectCurrentDriverInfo = createSelector(
  selectCurrentDriver,
  (driver) => (driver.info ? driver.info : "")
);
